import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=35acd9f2&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"
import style0 from "./Blog.vue?vue&type=style&index=0&id=35acd9f2&prod&lang=scss&scoped=true&"
import style1 from "./Blog.vue?vue&type=style&index=1&id=35acd9f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35acd9f2",
  null
  
)

export default component.exports